<form [formGroup]="cardDetailsForm">
    <div class="row mb-1">
      <div class="col-xs-12 col-md-3">
        <label for="username">Full Name (as appears on card)</label>
      </div>
      <div class="col-xs-12 col-md-4 col-lg-4">
        <input type="text" nbinput name="username" placeholder="Full name as it appears on your card"  required class="form-control" formControlName="name">
        <r247-validation-message errorMessage="Please enter the cardholder name" [showError]="cardholderName.errors?.required && cardholderName.touched"></r247-validation-message>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xs-12 col-md-3">
        <label for="cardNumber">Card number</label>
      </div>
      <div class="col-xs-12 col-md-4 col-lg-4">
        <div id="stripe-card-number" class="form-control stripe-input"></div>
        <r247-validation-message [errorMessage]="stripeInitError" [showError]="!!stripeInitError"></r247-validation-message>
        <r247-validation-message errorMessage="Please enter the card number"   [showError]="stripeState.number.touched && stripeState.number.empty"></r247-validation-message>
        <r247-validation-message [errorMessage]="stripeState.number.error" [showError]="stripeState.number.touched && !!stripeState.number.error"></r247-validation-message>
      </div>
      <div class="col-xs-12 col-md-2 col-lg-2 mt-1 mt-md-0">
        <span class="text-secondary"><i class="fab fa-cc-visa fa-3x mr-2"></i></span>
        <span class="text-secondary"><i class="fab fa-cc-mastercard fa-3x"></i></span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xs-12 col-md-3">
        <label>Expiration</label>
      </div>
      <div class="col-xs-12 col-md-2 col-lg-2">
        <div id="stripe-card-expiry" class="form-control stripe-input"></div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="offset-md-3 offset-lg-3 col-xs-12 col-md-4 col-lg-4">
        <r247-validation-message errorMessage="Please enter the expiry date" [showError]="stripeState.expiry.touched && stripeState.expiry.empty"></r247-validation-message>
        <r247-validation-message [errorMessage]="stripeState.expiry.error" [showError]="stripeState.expiry.touched && !!stripeState.expiry.error"></r247-validation-message>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xs-12 col-md-3">
        <label data-toggle="tooltip" title="Three-digits code on the back of your card">CVC</label>
      </div>
      <div class="col-xs-12 col-md-1 col-lg-1">
        <div id="stripe-card-cvc" class="form-control stripe-input"></div>
      </div>
    </div>
    <div class="row">
      <div class="offset-md-3 offset-lg-3 col-xs-12 col-md-4 col-lg-4">
        <r247-validation-message errorMessage="Please enter the CVC" [showError]="stripeState.cvc.touched && stripeState.cvc.empty"></r247-validation-message>
        <r247-validation-message [errorMessage]="stripeState.cvc.error" [showError]="stripeState.cvc.touched && !!stripeState.cvc.error"></r247-validation-message>
      </div>
    </div>
    <div class="row mt-3" [class.d-none]="hideSaveCardDetails">
      <div class="offset-md-3 offset-lg-3 col-xs-12 col-md-9 col-lg-9">
        <div class="form-check">
          <input class="form-check-input" formControlName="saveCardDetails" name="save-card-details"  type="checkbox" [attr.disabled]="forceSaveCardDetails ? true : null">
          <label class="ml-3" for="auto-top-up">Save details for future use (your details will be saved securely with Stripe)</label>
        </div>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-xs-12 col-md-3">
        <label for="cardDescription">Card Description</label>
      </div>
      <div class="col-xs-12 col-md-4 col-lg-4">
        <input type="text" placeholder="Card description e.g. Accounts Credit Card"   class="form-control" formControlName="cardDescription" [attr.disabled]="!saveCardDetails.value ? true : null" [required]="saveCardDetails.value">
        <r247-validation-message errorMessage="Please enter a description of the card e.g. Accounts Credit Card" [showError]="cardDescription.errors?.required && cardDescription.touched"></r247-validation-message>
      </div>
    </div>
  </form>